module.exports = __webpack_public_path__ + "static/img/title3.871d188.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title3.jpg
// module id = gvoR
// module chunks = 0